// data
const rekeningBank = () => ({})
const rekeningBankDetail = () => ({})
const rekeningAtasNama = () => []
const akunKeuangan = () => ({})
const riwayatTransfer = () => ({})
const riwayatTransferDetail = () => ({})

// filter
const pagination = () => ({
	limit: 20,
	offset: 0,
	length: 0,
	pageNumber: 0,
});
const paginationRiwayatTransfer = () => ({
	limit: 20,
	offset: 0,
	length: 0,
	pageNumber: 0,
});
const search = () => ({
	key: "",
});
const searchRiwayatTransfer = () => ({
	key: "",
});

const state = {
	// data
	rekeningBank: rekeningBank(),
	rekeningBankDetail: rekeningBankDetail(),
	rekeningAtasNama: rekeningAtasNama(),
	akunKeuangan: akunKeuangan(),
	riwayatTransfer: riwayatTransfer(),
	riwayatTransferDetail: riwayatTransferDetail(),

	// filter
	pagination: pagination(),
	paginationRiwayatTransfer: paginationRiwayatTransfer(),
	search: search(),
	searchRiwayatTransfer: searchRiwayatTransfer(),
	isSearch: false,
	isSearchRiwayatTransfer: false,

	scrollPosition: 0,
	scrollPositionRiwayatTransfer: 0,
}

export {
	state as default,
	rekeningBank,
	rekeningBankDetail,
	rekeningAtasNama,
	akunKeuangan,
	pagination,
	paginationRiwayatTransfer,
	riwayatTransfer,
	riwayatTransferDetail,
	search,
	searchRiwayatTransfer,
}